/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewBrandFinderDetails } from './CRSFSecReviewBrandFinderDetails';
import {
    CRSFSecReviewBrandFinderDetailsFromJSON,
    CRSFSecReviewBrandFinderDetailsFromJSONTyped,
    CRSFSecReviewBrandFinderDetailsToJSON,
} from './CRSFSecReviewBrandFinderDetails';

/**
 * 
 * @export
 * @interface CRSFSecReviewDomainExpansionItem
 */
export interface CRSFSecReviewDomainExpansionItem {
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewDomainExpansionItem
     */
    brand_finder: string;
    /**
     * 
     * @type {CRSFSecReviewBrandFinderDetails}
     * @memberof CRSFSecReviewDomainExpansionItem
     */
    brand_finder_details?: CRSFSecReviewBrandFinderDetails;
}

/**
 * Check if a given object implements the CRSFSecReviewDomainExpansionItem interface.
 */
export function instanceOfCRSFSecReviewDomainExpansionItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "brand_finder" in value;

    return isInstance;
}

export function CRSFSecReviewDomainExpansionItemFromJSON(json: any): CRSFSecReviewDomainExpansionItem {
    return CRSFSecReviewDomainExpansionItemFromJSONTyped(json, false);
}

export function CRSFSecReviewDomainExpansionItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewDomainExpansionItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brand_finder': json['brand_finder'],
        'brand_finder_details': !exists(json, 'brand_finder_details') ? undefined : CRSFSecReviewBrandFinderDetailsFromJSON(json['brand_finder_details']),
    };
}

export function CRSFSecReviewDomainExpansionItemToJSON(value?: CRSFSecReviewDomainExpansionItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'brand_finder': value.brand_finder,
        'brand_finder_details': CRSFSecReviewBrandFinderDetailsToJSON(value.brand_finder_details),
    };
}

